import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { goToOrganizationUpgrade } from 'data/ui/actions'
import { getNoteResourcesUsage } from 'data/organizationResourcesUsage/selectors'
import { Button, Text } from 'components/base'
import Illustration from './IncentiveIllustration.png'

export const IncentiveModalContent = ({ closeModal }) => {
  const dispatch = useDispatch()
  const { limit } = useSelector(getNoteResourcesUsage)

  const handleGoToUpgrade = () =>
    dispatch(goToOrganizationUpgrade({ incentiveId: 'NotesLimit' }))

  return (
    <div className="slite-design-system">
      <img
        alt="incentive-illustratioon"
        src={Illustration}
        style={{ pointerEvents: 'none' }}
      />
      <div className="background-shade-100 padding-vertical-larger padding-horizontal-large flexbox flexbox-column flexbox-align-center center-text">
        <Text.Title>Create unlimited docs</Text.Title>
        <Text.Detail className="margin-vertical-large line-height-larger">
          <span className="shade-05 font-size-normal">
            Your team is about to reach the {limit} free docs/month limit.
            Upgrade to keep writing without limits and unlock additional
            features.
          </span>
        </Text.Detail>
        <Button.Primary
          className="margin-vertical-small"
          onClick={handleGoToUpgrade}
        >
          Upgrade
        </Button.Primary>

        <Text.SmallDetail
          onClick={closeModal}
          className="underline pointer padding-top-large"
        >
          or upgrade later
        </Text.SmallDetail>
      </div>
    </div>
  )
}
